import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

function isMobile() {
  return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
}

// Helper to extract filename from Content-Disposition header
function getFileNameFromHeader(header) {
  if (!header) return 'Order.pdf';
  const match = header.match(/filename="?([^"]+)"?/);
  return match ? match[1] : 'stockout-reqid-form..pdf';
}

export default function PrintStockOutReq() {
  const { stockoutreqObj } = useSelector((state) => state.manufslice.stockoutreqDashboard);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [mobileDownloadUrl, setMobileDownloadUrl] = useState(null);
  const [mobileDownloadName, setMobileDownloadName] = useState('');
  const [mobileDownloadSuccess, setMobileDownloadSuccess] = useState(false);
  const [fileName, setFileName] = useState('');

  useEffect(() => {
    let url = null;
    const fetchPdf = async () => {
      try {
        const token = localStorage.getItem("JWT");
        const response = await fetch('https://api.manuf.appmachine.in/exposed/getstockoutreqpdf', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
          body: JSON.stringify({ stockoutReqId: stockoutreqObj.id }),
        });
        if (!response.ok) throw new Error('Network response was not ok');
        const blob = await response.blob();
        url = URL.createObjectURL(blob);

        // Get filename from Content-Disposition header
        const contentDisposition = response.headers.get('Content-Disposition');
        const filename = getFileNameFromHeader(contentDisposition);
        setFileName(filename);

        if (isMobile()) {
          // Download PDF on mobile with correct filename
          const link = document.createElement('a');
          link.href = url;
          link.download = filename;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          setMobileDownloadUrl(url);
          setMobileDownloadName(filename);
          setMobileDownloadSuccess(true);
        } else {
          setPdfUrl(url);
        }
      } catch (error) {
        console.error('Error fetching PDF:', error);
        setPdfUrl(null);
      }
    };
    if (stockoutreqObj?.id) fetchPdf();

    // Cleanup: revoke object URL when component unmounts or pdfUrl changes
    return () => {
      if (url) URL.revokeObjectURL(url);
      if (mobileDownloadUrl) URL.revokeObjectURL(mobileDownloadUrl);
    };
    // eslint-disable-next-line
  }, [stockoutreqObj?.id]);

  if (isMobile() && mobileDownloadSuccess) {
    return (
      <div
        style={{
          maxWidth: 400,
          margin: '40px auto',
          padding: 24,
          borderRadius: 12,
          boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
          background: '#fff',
          textAlign: 'center',
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginBottom: 16,
          }}
        >
          <span
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: '#e6f4ea',
              borderRadius: '50%',
              width: 56,
              height: 56,
              marginRight: 0,
            }}
          >
            <CheckCircleIcon style={{ color: '#2e7d32', fontSize: 40 }} />
          </span>
        </div>
        <div style={{ color: 'green', fontWeight: 600, fontSize: 18, marginBottom: 16 }}>
          stockout-reqid-{stockoutreqObj.id}-form. is downloaded successfully!!!
        </div>
        <div style={{ fontWeight: 600, marginBottom: 16 }}>
          To print file, Please open file from Download folder.
        </div>
        <div style={{ fontWeight: 600, marginBottom: 16 }}>OR</div>
        <a
          href={mobileDownloadUrl}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: 'inline-block',
            padding: '10px 24px',
            background: '#1976d2',
            color: '#fff',
            borderRadius: 6,
            textDecoration: 'none',
            fontWeight: 500,
            marginTop: 8,
          }}
        >
          Open PDF in New Tab
        </a>
      </div>
    );
  }

  return (
    <div style={{ width: '100%', height: '80vh' }}>
      {pdfUrl ? (
        <iframe
          src={pdfUrl}
          title="Order PDF"
          width="100%"
          height="100%"
          style={{ border: 'none' }}
        />
      ) : (
        <div>Loading PDF...</div>
      )}
    </div>
  );
}